import {makeAutoObservable} from "mobx";
import {IRMAQuestionMedia} from "../rma-types";


class QuestionMediaStore {
    private _model: IRMAQuestionMedia = {} as IRMAQuestionMedia;
    constructor(model: IRMAQuestionMedia) {
        makeAutoObservable(this, {}, {autoBind: true});
        this._setModel(model);
    }
    
    private _setModel(model: IRMAQuestionMedia){
        this._model = this._ensureValidModel(model);
    }
    
    public get id(): number { return this._model.id; }
    public get filename(): string { return this._model.filename; }
    public get isSaved(): boolean { return this._model.is_saved; }
    public get src(): string { return this._model._full_url; }
    
    private _ensureValidModel(model: IRMAQuestionMedia){
        return {
            ...model,
            is_saved: Boolean(model.is_saved)
        }
    }
}

export { QuestionMediaStore as default };
